export default __webpack_public_path__ + "static/content-l7-2-f81b9c8a14b5c3433cacd3e37cb38f2f.png";